import { NewModalClassificationComponent } from './group-key/new-modal/new-modal.component';
import { CommonModule } from '@angular/common';
import { inject, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { SharedModule } from '@shared/shared.module';
import { SportParameterizationModule } from '../sport-parameterization/sport-parameterization.module';
import { ClashDefinitionComponent } from './clash-definition/clash-definition.component';
import { GroupKeyComponent } from './group-key/group-key.component';
import { ModalEquipeComponent } from './group-key/modal-equipe/modal-equipe.component';
import { ModalParticipanteComponent } from './group-key/modal-participante/modal-participante.component';
import { KeyClassificationComponent } from './key-classification/key-classification.component';
import { KeyGenerationComponent } from './key-generation/key-generation.component';
import { ModalAddRegistrationsForKeyComponent } from './modal-add-registrations-for-key/modal-add-registrations-for-key.component';
import { ModalArenaComponent } from './modal-arena/modal-arena.component';
import { StepParameterizationComponentForm } from './step-parameterization-form/step-parameterization-form.component';
import { StepParameterizationComponentList } from './step-parameterization-list/step-parameterization-list.component';
import { StepParameterizationRoutingModule } from './step-parameterization-routing.module';
import { KeyManagementComponent } from './key-management/key-management.component';
import { RoundManagementComponent } from './round-management/round-management.component';
import { RoundManagementWithLocalComponent } from './round-management/round-management-with-local/round-management-with-local.component';
import { RoundManagementInfoComponent } from './round-management/components/round-managment-info/round-management-info.component';
@NgModule({
  declarations: [
    StepParameterizationComponentForm,
    StepParameterizationComponentList,
    KeyGenerationComponent,
    GroupKeyComponent,
    ModalArenaComponent,
    ModalAddRegistrationsForKeyComponent,
    KeyClassificationComponent,
    ClashDefinitionComponent,
    ModalEquipeComponent,
    ModalParticipanteComponent,
    KeyManagementComponent,
    NewModalClassificationComponent,
    RoundManagementComponent,
    RoundManagementWithLocalComponent,
    RoundManagementInfoComponent,
  ],
  exports: [KeyGenerationComponent],
  imports: [
    FontAwesomeModule,
    CommonModule,
    ReactiveFormsModule,
    StepParameterizationRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    SportParameterizationModule,
  ],
})
export class StepParameterizationModule {
  library = inject(FaIconLibrary);
  constructor() {
    this.library.addIconPacks(fas, far);
  }
}
